import { Link } from '@mui/material';
import { CLottie, CModal } from 'components/atoms';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useCategoryDocumentsQuery } from 'services/official-document';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import CCheckboxWithLabel from '../checkbox/checkbox-with-label';
import { getLanguageId } from 'utils/functions';
import constants from 'utils/constants';

export enum DocumentCode {
  KVKK = 'KVKK',
  ETK = 'ETK',
  AYDINLATMA = 'AYDINLATMA',
  ON_BILGILENDIRME = 'ON_BILGILENDIRME',
  GIZLILIK_POLITIKASI = 'GIZLILIK_POLITIKASI',
  MESAFELI_SATIS_SOZLESMESI = 'MESAFELI_SATIS_SOZLESMESI',
  KULLANIM_KOSULLARI = 'KULLANIM_KOSULLARI',
  ONAM_FORMU = 'ONAM_FORMU',
  BILGI_AL = 'BILGI_AL',
  DOKTOR_GIZLILIK_FORMU = 'DOKTOR_GIZLILIK_FORMU',
  DIGER = 'DIGER',
}

type Prop = {
  field?: FieldValues;
  isHasProfile?: boolean;
  basketItems?: { type: number | string; id: number }[];
  documentCode: DocumentCode; // codeler backend ile senkronize olmali
  actionType: 'checkbox' | 'link';
  isOpenDetailDocument?: boolean;
};

export default function OfficialDocumentModal({
  field,
  documentCode,
  actionType,
  isOpenDetailDocument = false,
}: Prop) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const langId = getLanguageId();

  const { data: officialDocument, isLoading: isOfficialDocumentLoading } = useCategoryDocumentsQuery({
    categoryCode: documentCode,
    isActive: true,
  });
  const data = officialDocument?.data;

  const filteredData = data?.find(
    (item) =>
      item.relatedBasketItemType === null && item.applicationIds.includes(constants.applicationId)
  );

  const dataByLang = filteredData?.officialDocumentResources.find((item) => item.languageId === langId);

  if (isOfficialDocumentLoading) {
    return <CLottie isFullPage />;
  }

  return (
    <>
      {actionType === 'checkbox' && (
        <CCheckboxWithLabel
          {...field}
          checked={field?.value}
          label={
            <span
              className="underline hover:text-secondary hover:underline"
              onClick={(e) => {
                e.preventDefault();
                isOpenDetailDocument && setIsModalOpen(true);
              }}
            >
              {dataByLang?.name}
            </span>
          }
        />
      )}

      {actionType === 'link' && (
        <Link
          className="ml-8 cursor-pointer text-body12 text-secondary"
          onClick={() => setIsModalOpen(true)}
        >
          {dataByLang?.name}
        </Link>
      )}

      <CModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="h-[80%] w-[90%] max-w-[800px] overflow-scroll"
      >
        <>
          {isOfficialDocumentLoading ? (
            <CLottie isFullPage />
          ) : (
            dataByLang?.text && (
              <SunEditor
                setContents={dataByLang?.text ?? ''}
                readOnly
                hideToolbar
                height="100%"
                setOptions={{
                  resizingBar: false,
                }}
              />
            )
          )}
        </>
      </CModal>
    </>
  );
}

